import React from 'react';
import { Button } from '../components/ui/Button';
import { MetricCard } from '../components/MetricCard';
import { CreatorTable, Creator } from '../components/CreatorTable';
import { ArrowLeft, Users, BarChart3, Globe, Download, MessageCircle, Briefcase, Layers, ListTodo, Settings, User } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function ManagerDashboard() {
  const navigate = useNavigate();
  // Mock Data
  const creators: Creator[] = [{
    id: '1',
    name: 'Sarah Klein',
    handle: 'sarah.style',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=800&auto=format&fit=crop&q=60',
    followers: 245000,
    engagement: 3.2,
    growth: 2.4,
    status: 'active'
  }, {
    id: '2',
    name: 'Tom Weber',
    handle: 'tom_travels',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=800&auto=format&fit=crop&q=60',
    followers: 89000,
    engagement: 5.8,
    growth: 12.5,
    status: 'growing'
  }, {
    id: '3',
    name: 'Lisa Schmidt',
    handle: 'lisa.fitness',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=800&auto=format&fit=crop&q=60',
    followers: 156000,
    engagement: 4.1,
    growth: -0.5,
    status: 'stable'
  }, {
    id: '4',
    name: 'Felix Meyer',
    handle: 'felix_tech',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=800&auto=format&fit=crop&q=60',
    followers: 42000,
    engagement: 6.2,
    growth: 8.9,
    status: 'growing'
  }, {
    id: '5',
    name: 'Emma Wilson',
    handle: 'emma.eats',
    avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=800&auto=format&fit=crop&q=60',
    followers: 310000,
    engagement: 2.8,
    growth: 1.1,
    status: 'active'
  }, {
    id: '6',
    name: 'David Brown',
    handle: 'david.photo',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&auto=format&fit=crop&q=60',
    followers: 12000,
    engagement: 8.5,
    growth: 15.2,
    status: 'growing'
  }, {
    id: '7',
    name: 'Sophie Miller',
    handle: 'sophie_art',
    avatar: 'https://images.unsplash.com/photo-1554151228-14d9def656ec?w=800&auto=format&fit=crop&q=60',
    followers: 78000,
    engagement: 4.5,
    growth: 0.2,
    status: 'stable'
  }, {
    id: '8',
    name: 'James Wilson',
    handle: 'james.gym',
    avatar: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=800&auto=format&fit=crop&q=60',
    followers: 195000,
    engagement: 3.9,
    growth: -1.2,
    status: 'active'
  }];
  return <div className="min-h-screen bg-gray-50 pb-12" data-id="element-1095">
      {/* Header */}
      <header className="bg-white border-b sticky top-0 z-10" data-id="element-1096">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between" data-id="element-1097">
          <div className="flex items-center" data-id="element-1098">
            <Button variant="ghost" size="sm" className="mr-4" onClick={() => navigate('/')} data-id="element-1099">
              <ArrowLeft className="h-4 w-4 mr-2" data-id="element-1100" /> Back
            </Button>
            <div className="flex items-center space-x-3 cursor-pointer" onClick={() => navigate('/manager/profile')} data-id="element-1101">
              <div className="h-8 w-8 rounded-lg bg-blue-600 flex items-center justify-center text-white font-bold text-xs hover:bg-blue-700 transition-colors" data-id="element-1102">
                TM
              </div>
              <span className="font-semibold text-gray-900" data-id="element-1103">
                Talent Management Inc.
              </span>
            </div>
          </div>
          <div className="flex items-center space-x-4" data-id="element-1104">
            <Button variant="secondary" size="sm" data-id="element-1105">
              <Download className="h-4 w-4 mr-2" data-id="element-1106" /> Export Report
            </Button>
            <Button variant="secondary" size="sm" onClick={() => navigate('/chat')} data-id="element-1107">
              <MessageCircle className="h-4 w-4 mr-2" data-id="element-1108" /> Messages
            </Button>
            <Button variant="ghost" size="sm" onClick={() => navigate('/manager/profile')} className="h-8 w-8 p-0" data-id="element-1109">
              <Settings className="h-4 w-4" data-id="element-1110" />
            </Button>
            <Button variant="primary" size="sm" className="bg-blue-600 hover:bg-blue-700" data-id="element-1111">
              Add Creator
            </Button>
          </div>
        </div>

        {/* Tabs */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1112">
          <div className="flex space-x-8 -mb-px" data-id="element-1113">
            <button className="pb-4 text-sm font-medium text-blue-600 border-b-2 border-blue-600" data-id="element-1114">
              Overview
            </button>
            <button onClick={() => navigate('/manager/creators')} className="pb-4 text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent" data-id="element-1115">
              Creators
            </button>
            <button onClick={() => navigate('/manager/brands')} className="pb-4 text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent" data-id="element-1116">
              Brands
            </button>
            <button onClick={() => navigate('/manager/projects')} className="pb-4 text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent" data-id="element-1117">
              Projects
            </button>
            <button onClick={() => navigate('/manager/tasks')} className="pb-4 text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent" data-id="element-1118">
              Tasks
            </button>
            <button onClick={() => navigate('/manager/calendar')} className="pb-4 text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent" data-id="element-1119">
              Calendar
            </button>
            <button onClick={() => navigate('/manager/platforms')} className="pb-4 text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent" data-id="element-1120">
              Platforms
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-1121">
        <div className="mb-8" data-id="element-1122">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-1123">
            Portfolio Overview
          </h1>
          <p className="text-muted-foreground" data-id="element-1124">
            Manage your roster and track overall performance.
          </p>
        </div>

        {/* Summary Metrics */}
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6 mb-8" data-id="element-1125">
          <MetricCard title="Total Creators" value="8" trend={2} trendLabel="new this month" icon={<Users className="h-4 w-4 text-blue-500" data-id="element-1127" />} data-id="element-1126" />
          <MetricCard title="Total Reach" value="1.1M" trend={5.8} icon={<Globe className="h-4 w-4 text-purple-500" data-id="element-1129" />} data-id="element-1128" />
          <MetricCard title="Avg. Engagement" value="4.8%" trend={-0.5} icon={<BarChart3 className="h-4 w-4 text-orange-500" data-id="element-1131" />} data-id="element-1130" />
          <MetricCard title="Active Brands" value="3" trend={1} icon={<Briefcase className="h-4 w-4 text-green-500" data-id="element-1133" />} data-id="element-1132" />
          <MetricCard title="Active Projects" value="5" trend={2} icon={<Layers className="h-4 w-4 text-indigo-500" data-id="element-1135" />} data-id="element-1134" />
        </div>

        {/* Main Table */}
        <CreatorTable creators={creators} data-id="element-1136" />
      </main>
    </div>;
}